import { changePasswordStyles } from "@insite/content-library/Widgets/ChangePassword/ChangePassword";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { COLORS } from "@tSurya/theme/design";
import { css } from "styled-components";

changePasswordStyles.userInformationTitle = {
    variant: "h4",
    as: "h2",
    css: css`
        color: ${getColor("text.main")};
    `,
};
changePasswordStyles.passwordRequirementsGridItem = {
    width: 12,
    css: css`
        color: ${getColor("text.main")};
    `,
};
changePasswordStyles.userInformationGridItem = {
    width: 12,
    css: css`
        div[class^="FormFieldStyle"] {
            label {
                color: ${getColor("text.main")} !important;
            }
        }
    `,
};
changePasswordStyles.showPasswordsGridItem = {
    width: 12,
    css: css`
        label {
            color: ${getColor("text.main")} !important;
        }
    `,
};
changePasswordStyles.passwordGridContainer = {
    css: css`
        margin: initial;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                null,
                null,
                css`
                    max-width: 300px;
                `,
                css`
                    max-width: 300px;
                `,
                css`
                    max-width: 300px;
                `,
            ])}
    `,
    gap: 10,
};
